import React, { Component } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore';
import WorkStore from '../Kanban/WorkStore';
import ClientColumn from './ClientColumn';
import ClientWorkDialog from './ClientWorkDialog';
import './clientBoard.css'

export default class ClientBoard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projects: [],
            works: []
        };

        this.columns = [
            { name: 'Backlog', id: 'e3e8b238-a870-4dc1-ab2b-e2cbe7f9b6dc' },
            { name: 'Ready to work', id: 'b555b916-8367-46f5-8200-594c2fdf7443' },
            { name: 'In Progress', id: 'cc2e91c6-964c-44f2-845c-efdcf60f9bb1' },
            { name: 'Ready To Testing', id: '5981de5b-476d-4d18-abb7-d14201eba1a6' },
            { name: 'Testing', id: '317701e4-9088-4ee6-9f12-90280a4f5cca' },
            { name: 'Waiting Customer', id: '26dc59d4-a3e9-4cae-a991-ee420a3866ad' },
            { name: 'Done', id: '413d852e-d294-418b-b2ed-038a2d169180' }
        ];

        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();    
        var token = localStorage.getItem("token");
        fetch('api/Project/GetClientProject', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({projects: result})
                }).catch((err) => console.log(err));
            }
        });

        MainStore.setMaskVisible();
        fetch('api/Work/GetClientWork', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ works: result })
                }).catch((err) => console.log(err));
            }
        });
    }

    handleCardOpen(work) {
        WorkStore.openWorkDialog(work);
    }

    render() {
        return (
            <div>
                <div className="client-projects-block">
                    {this.state.projects.map(p => <div className="project-item">
                        <div>{p.name}({p.status})</div>
                        <div>План проекта {p.clientHours}ч. Всего учтено {p.totalAll}ч. Из них закрыто {p.totalClosed}ч.</div>
                        <LinearProgress variant="buffer" value={100 * p.totalClosed / p.clientHours} valueBuffer={100 * p.totalAll / p.clientHours} />
                    </div>)}
                </div>    
                {this.columns.map((column) => {
                    return (
                        <ClientColumn
                            name={column.name}
                            id={column.id}
                            onTimeChange={this.onTimeChange}
                            works={this.state.works.filter((w) => { return w.statusId === column.id; })}
                            onWorkUpdate={this.handleWorkFlagUpdate}
                            key={column.id}
                            onCardOpen={this.handleCardOpen}
                        />
                        );
                })}
                <ClientWorkDialog />
            </div>);
    }
}